import styled from "styled-components";

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 1rem;
  resize: vertical;
  min-height: ${(props) => (props.$size === "small" ? "80px" : "120px")};
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #000000;
  }

  &:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
